import { useState, MouseEvent, HTMLAttributeAnchorTarget } from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";

// custom
import { PermittableMenuItem, permissionValues } from "components/common/PermissionComponents";

// const options = [
//   'None',
//   'Atria',
//   'Callisto',
//   'Dione',
// ];

export type Option = {
  children: React.ReactNode;
  handleClick?: () => void;
  link?: string;
  download?: boolean;
  linkTarget?: HTMLAttributeAnchorTarget;
  permissionInfo?: { resource: string; permission: permissionValues };
  notShow?: boolean;
};
export type DotMenuProps = {
  options: Option[];
  showBorder?: boolean;
};
const DotMenu: React.FC<DotMenuProps> = (props) => {
  const { options, showBorder } = props;

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleOpen = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const overrideHandleClick = (option: Option) => {
    return () => {
      if (option.handleClick) {
        option.handleClick();
      }
      handleClose();
    };
  };

  // NOTE: linkをこれで行う場合、以下のデメリットが有る。
  //   - [確定情報]linkの範囲がaタグ内のみになるので、MenuItemの端の部分がlinkにならない
  //   - [非確定情報]画面開いた直後等がリンクになって無いことが有る..っぽい(これ要因化は不明)
  //     https://nitoel.backlog.com/view/NITOEL_DEV-656 に動画も載っているので参照のこと。
  //  今parts/detail/detailPanel.tsx内でこれを使わないようにしたので、それでしばらく様子見てこれが原因そうだったら
  //  他にlink使ってるところも全てlocation.hrefに書き換えて、ここのlinkを指定できなくする。
  const overrideContent = (option: Option) => {
    if (option.link) {
      return (
        <a href={option.link} download={!!option.download} target={option.linkTarget}>
          {option.children}
        </a>
      );
    } else {
      return <>{option.children}</>;
    }
  };

  return (
    <div>
      <IconButton onClick={handleOpen} sx={showBorder ? { border: 1, bgcolor: "white" } : {}}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {options
          .filter((option) => option.notShow != true)
          .map((option, idx) =>
            option.permissionInfo ? (
              <PermittableMenuItem
                key={idx}
                onClick={overrideHandleClick(option)}
                resource={option.permissionInfo.resource}
                permission={option.permissionInfo.permission}
              >
                {overrideContent(option)}
              </PermittableMenuItem>
            ) : (
              <MenuItem key={idx} onClick={overrideHandleClick(option)}>
                {overrideContent(option)}
              </MenuItem>
            ),
          )}
      </Menu>
    </div>
  );
};

export default DotMenu;
